import { render, staticRenderFns } from "./BillingAccountsView.vue?vue&type=template&id=56b5d73e&scoped=true&"
import script from "./BillingAccountsView.vue?vue&type=script&lang=js&"
export * from "./BillingAccountsView.vue?vue&type=script&lang=js&"
import style0 from "./BillingAccountsView.vue?vue&type=style&index=0&id=56b5d73e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5d73e",
  null
  
)

export default component.exports